
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const qs = (s, c=document) => c.querySelector(s);
  const qsa = (s, c=document) => [...c.querySelectorAll(s)];
  const api = (path) => root + path.replace(/^\//, '');
  const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'MXN';

  const escapeHTML = (value='') => String(value).replace(/[&<>"']/g, ch => ({
    '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'
  }[ch]));

  const money = (cents=0) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang.startsWith('es') ? 'es-MX' : undefined, {
        style:'currency', currency, maximumFractionDigits:0
      }).format(Number(cents)/100);
    } catch(e) {
      return '$' + Math.round(Number(cents)/100);
    }
  };

  let toastTimer;
  function toast(message, type='normal') {
    const el = qs('[data-rp-toast]');
    if (!el) return;
    el.textContent = message;
    el.style.borderColor = type === 'error' ? 'rgba(240,154,145,.7)' : '';
    el.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-show'), 2400);
  }

  const drawer = qs('[data-rp-cart-drawer]');
  const overlay = qs('[data-rp-cart-overlay]');
  function openCart() {
    if (!drawer || !overlay) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    document.body.classList.add('rp-lock');
  }
  function closeCart() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    document.body.classList.remove('rp-lock');
  }

  async function fetchJSON(path, options={}) {
    const response = await fetch(api(path), options);
    let data = {};
    try { data = await response.json(); } catch(e) {}
    if (!response.ok) {
      const error = new Error(data.description || data.message || 'No se pudo completar la acción.');
      error.data = data;
      throw error;
    }
    return data;
  }

  function productImage(item) {
    const map = window.RP_PRODUCT_IMAGES || {};
    return map[item.handle] || item.image || map.default || '';
  }

  function renderCart(cart) {
    qsa('[data-cart-count]').forEach(el => el.textContent = cart.item_count || 0);
    const itemsEl = qs('[data-rp-cart-items]');
    const subtotalEl = qs('[data-rp-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price || 0);
    if (!itemsEl) return;

    if (!cart.items || !cart.items.length) {
      itemsEl.innerHTML = `
        <div class="rp-cart-empty">
          <strong>Tu carrito está vacío</strong>
          <p>Elige una fragancia y selecciona 5 ml o 10 ml.</p>
          <button class="rp-btn rp-btn-gold" type="button" data-rp-cart-shop>VER COLECCIÓN</button>
        </div>`;
      return;
    }

    itemsEl.innerHTML = cart.items.map((item, index) => {
      const props = Object.entries(item.properties || {})
        .filter(([key, value]) => value && !String(key).startsWith('_'))
        .map(([key, value]) => `<div>${escapeHTML(key)}: ${escapeHTML(value)}</div>`).join('');
      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? `<div class="rp-cart-line-variant">${escapeHTML(item.variant_title)}</div>` : '';
      const image = productImage(item);
      return `
        <div class="rp-cart-line" data-rp-cart-line data-line="${index + 1}">
          ${image ? `<img class="rp-cart-line-img" src="${escapeHTML(image)}" alt="${escapeHTML(item.product_title)}">` : `<div class="rp-cart-line-img"></div>`}
          <div>
            <div class="rp-cart-line-title">${escapeHTML(item.product_title)}</div>
            ${variant}
            ${props ? `<div class="rp-cart-line-properties">${props}</div>` : ''}
            <div class="rp-qty">
              <button type="button" aria-label="Quitar una unidad" data-rp-qty="-1">−</button>
              <span>${item.quantity}</span>
              <button type="button" aria-label="Agregar una unidad" data-rp-qty="1">+</button>
              <button type="button" class="rp-remove" data-rp-remove>Eliminar</button>
            </div>
          </div>
          <div class="rp-cart-line-price">${money(item.final_line_price)}</div>
        </div>`;
    }).join('');
  }

  async function refreshCart(open=false) {
    try {
      const cart = await fetchJSON('cart.js', {headers:{'Accept':'application/json'}});
      renderCart(cart);
      if (open) openCart();
      return cart;
    } catch(e) {
      toast(e.message, 'error');
    }
  }

  async function addItems(items, button) {
    const old = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'AGREGANDO…';
    }
    try {
      await fetchJSON('cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items})
      });
      await refreshCart(true);
      toast('Agregado al carrito ✓');
    } catch(e) {
      toast(e.message || 'No se pudo agregar.', 'error');
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = old;
      }
    }
  }

  function selectSize(button) {
    const card = button.closest('[data-rp-product-card], [data-rp-product-detail]');
    if (!card || button.disabled) return;
    qsa('[data-rp-size]', card).forEach(el => el.classList.remove('is-selected'));
    button.classList.add('is-selected');
    card.dataset.variantId = button.dataset.variantId || '';
    const add = qs('[data-rp-add-product]', card);
    if (add) {
      add.disabled = !card.dataset.variantId;
      add.textContent = card.dataset.variantId ? (add.dataset.preorderLabel || 'AÑADIR AL CARRITO') : 'NO DISPONIBLE';
    }
    const price = qs('[data-rp-selected-price]', card);
    if (price && button.dataset.price) price.textContent = button.dataset.price;
  }

  // ---- Arma tu propio trío: precio dinámico por combinación ----
  // Orden canónico usado para armar la clave/SKU sin importar en qué orden
  // el cliente eligió las fragancias. Debe coincidir con los SKU de los
  // productos backend "Trío Personalizado 5/10 ml".
  const TRIO_ORDER = ['9PM', 'MANDARIN', 'HAWAS', 'HAWASICE', 'ASAD', 'KHAMRAH'];

  function getTrioPricing() {
    if (window.__RP_TRIO_PRICING) return window.__RP_TRIO_PRICING;
    const el = qs('[data-rp-trio-pricing]');
    try { window.__RP_TRIO_PRICING = el ? JSON.parse(el.textContent) : {}; }
    catch(e) { window.__RP_TRIO_PRICING = {}; }
    return window.__RP_TRIO_PRICING;
  }

  function getScentAvailability() {
    if (window.__RP_SCENT_AVAILABILITY) return window.__RP_SCENT_AVAILABILITY;
    const el = qs('[data-rp-scent-availability]');
    try { window.__RP_SCENT_AVAILABILITY = el ? JSON.parse(el.textContent) : {}; }
    catch(e) { window.__RP_SCENT_AVAILABILITY = {}; }
    return window.__RP_SCENT_AVAILABILITY;
  }

  function getScentPrices() {
    if (window.__RP_SCENT_PRICES) return window.__RP_SCENT_PRICES;
    const el = qs('[data-rp-scent-prices]');
    try { window.__RP_SCENT_PRICES = el ? JSON.parse(el.textContent) : {}; }
    catch(e) { window.__RP_SCENT_PRICES = {}; }
    return window.__RP_SCENT_PRICES;
  }

  function updateBuilder(builder) {
    const ml = builder.dataset.ml || '';
    const values = qsa('[data-rp-builder-scent]', builder).map(s => s.value).filter(Boolean);
    const unique = new Set(values);
    const add = qs('[data-rp-builder-add]', builder);
    const status = qs('[data-rp-builder-status]', builder);
    const priceEl = qs('[data-rp-builder-price]', builder);
    const savingsEl = qs('[data-rp-builder-savings]', builder);
    delete builder.dataset.variantId;

    if (!ml) {
      if (status) status.textContent = '1. Elige 3×5 ml o 3×10 ml.';
      if (add) add.disabled = true;
      if (priceEl) priceEl.textContent = '—';
      if (savingsEl) savingsEl.textContent = '';
      return;
    }
    if (values.length < 3) {
      if (status) status.textContent = '2. Elige las tres fragancias.';
      if (add) add.disabled = true;
      if (priceEl) priceEl.textContent = '—';
      if (savingsEl) savingsEl.textContent = '';
      return;
    }
    if (unique.size < 3) {
      if (status) status.textContent = 'Las tres fragancias deben ser diferentes.';
      if (add) add.disabled = true;
      if (priceEl) priceEl.textContent = '—';
      if (savingsEl) savingsEl.textContent = '';
      return;
    }

    const availability = getScentAvailability();
    const unavailableCode = values.find(code => !(availability[code] && availability[code][ml]));
    if (unavailableCode) {
      if (status) status.textContent = 'Una de tus fragancias no tiene stock en ' + ml + ' ml ahora mismo. Elige otra.';
      if (add) add.disabled = true;
      if (priceEl) priceEl.textContent = '—';
      if (savingsEl) savingsEl.textContent = '';
      return;
    }

    const sorted = [...values].sort((a, b) => TRIO_ORDER.indexOf(a) - TRIO_ORDER.indexOf(b));
    const sku = 'TRIO' + ml + '-' + sorted.join('-');
    const pricing = getTrioPricing();
    const entry = pricing[ml] && pricing[ml][sku];

    if (!entry || !entry.available) {
      if (status) status.textContent = 'Esta combinación no está disponible ahora mismo.';
      if (add) add.disabled = true;
      if (priceEl) priceEl.textContent = '—';
      if (savingsEl) savingsEl.textContent = '';
      return;
    }

    builder.dataset.variantId = entry.id;
    if (priceEl) priceEl.textContent = money(entry.price_cents);
    if (savingsEl) {
      const scentPrices = getScentPrices();
      const sumCents = values.reduce((total, code) => {
        const perScent = scentPrices[code] && scentPrices[code][ml];
        return total + (typeof perScent === 'number' ? perScent : 0);
      }, 0);
      const savingsCents = sumCents - entry.price_cents;
      savingsEl.textContent = savingsCents > 0 ? 'AHORRAS ' + money(savingsCents) : '';
    }
    if (status) status.textContent = 'Listo para agregar al carrito.';
    if (add) add.disabled = false;
  }

  document.addEventListener('click', async (event) => {
    const size = event.target.closest('[data-rp-size]');
    if (size) {
      event.preventDefault();
      selectSize(size);
      return;
    }

    const addProduct = event.target.closest('[data-rp-add-product]');
    if (addProduct) {
      event.preventDefault();
      const card = addProduct.closest('[data-rp-product-card], [data-rp-product-detail]');
      const variantId = Number(card && card.dataset.variantId);
      if (!variantId) {
        toast('Selecciona 5 ml o 10 ml.', 'error');
        return;
      }
      await addItems([{id:variantId, quantity:1}], addProduct);
      return;
    }

    const addFixed = event.target.closest('[data-rp-add-fixed]');
    if (addFixed) {
      event.preventDefault();
      const variantId = Number(addFixed.dataset.variantId);
      if (!variantId) {
        toast('Falta importar el catálogo de productos.', 'error');
        return;
      }
      await addItems([{id:variantId, quantity:1}], addFixed);
      return;
    }

    const notifyToggle = event.target.closest('[data-rp-notify-toggle]');
    if (notifyToggle) {
      event.preventDefault();
      const card = notifyToggle.closest('[data-rp-product-card]');
      const form = card ? qs('[data-rp-notify-form]', card) : null;
      if (form) {
        const isHidden = form.hasAttribute('hidden');
        if (isHidden) { form.removeAttribute('hidden'); } else { form.setAttribute('hidden',''); }
        notifyToggle.setAttribute('aria-expanded', String(isHidden));
      }
      return;
    }

    const builderSize = event.target.closest('[data-rp-builder-size]');
    if (builderSize) {
      event.preventDefault();
      const builder = builderSize.closest('[data-rp-builder]');
      qsa('[data-rp-builder-size]', builder).forEach(el => el.classList.remove('is-selected'));
      builderSize.classList.add('is-selected');
      builder.dataset.ml = builderSize.dataset.ml || '';
      updateBuilder(builder);
      return;
    }

    const builderAdd = event.target.closest('[data-rp-builder-add]');
    if (builderAdd) {
      event.preventDefault();
      const builder = builderAdd.closest('[data-rp-builder]');
      const variantId = Number(builder.dataset.variantId);
      const selects = qsa('[data-rp-builder-scent]', builder);
      const codes = selects.map(s => s.value);
      const labels = selects.map(s => (s.options[s.selectedIndex] ? s.options[s.selectedIndex].text : ''));
      const ml = builder.dataset.ml;
      if (!variantId || codes.filter(Boolean).length !== 3 || new Set(codes).size !== 3) {
        updateBuilder(builder);
        toast('Completa tu combo con tres fragancias diferentes.', 'error');
        return;
      }
      const properties = {
        'Fragancia 1': labels[0],
        'Fragancia 2': labels[1],
        'Fragancia 3': labels[2],
        'Tamaño del combo': (ml === '5' ? '3×5 ml' : '3×10 ml')
      };
      await addItems([{id:variantId, quantity:1, properties}], builderAdd);
      return;
    }

    if (event.target.closest('[data-rp-cart-open]')) {
      event.preventDefault();
      await refreshCart(true);
      return;
    }
    if (event.target.closest('[data-rp-cart-close]') || event.target.closest('[data-rp-cart-overlay]')) {
      closeCart();
      return;
    }
    const shop = event.target.closest('[data-rp-cart-shop]');
    if (shop) {
      closeCart();
      const target = qs('#coleccion');
      if (target) target.scrollIntoView({behavior:'smooth'});
      return;
    }

    const qty = event.target.closest('[data-rp-qty]');
    if (qty) {
      const lineEl = qty.closest('[data-rp-cart-line]');
      const line = Number(lineEl.dataset.line);
      const current = Number(qs('.rp-qty span', lineEl).textContent);
      const next = Math.max(0, current + Number(qty.dataset.rpQty));
      qty.disabled = true;
      try {
        const cart = await fetchJSON('cart/change.js', {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({line, quantity:next})
        });
        renderCart(cart);
      } catch(e) { toast(e.message,'error'); }
      return;
    }

    const remove = event.target.closest('[data-rp-remove]');
    if (remove) {
      const line = Number(remove.closest('[data-rp-cart-line]').dataset.line);
      try {
        const cart = await fetchJSON('cart/change.js', {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({line, quantity:0})
        });
        renderCart(cart);
      } catch(e) { toast(e.message,'error'); }
      return;
    }

    const menuToggle = event.target.closest('[data-rp-menu-toggle]');
    if (menuToggle) {
      const menu = qs('[data-rp-mobile-menu]');
      const open = !menu.classList.contains('is-open');
      menu.classList.toggle('is-open', open);
      document.body.classList.toggle('rp-lock', open);
      menuToggle.setAttribute('aria-expanded', String(open));
      return;
    }
    if (event.target.closest('[data-rp-menu-close]') || event.target.closest('.rp-mobile-links a')) {
      const menu = qs('[data-rp-mobile-menu]');
      if (menu) menu.classList.remove('is-open');
      document.body.classList.remove('rp-lock');
      const toggle = qs('[data-rp-menu-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded','false');
    }
  });

  document.addEventListener('change', event => {
    const select = event.target.closest('[data-rp-builder-scent]');
    if (select) updateBuilder(select.closest('[data-rp-builder]'));
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      closeCart();
      const menu = qs('[data-rp-mobile-menu]');
      if (menu) menu.classList.remove('is-open');
      document.body.classList.remove('rp-lock');
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    qsa('[data-rp-builder]').forEach(updateBuilder);
    qsa('[data-rp-add-product]').forEach(btn => {
      const card = btn.closest('[data-rp-product-card]');
      if (card && btn.textContent.trim() === 'RESERVAR (PREORDEN)') btn.dataset.preorderLabel = 'RESERVAR (PREORDEN)';
    });
    refreshCart(false);
  });
})();
